<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1086_3188)">
<path d="M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z" fill="#FFA100" fill-opacity="0.2"/>
<path d="M14.6653 6.5L8.24869 12.9167L5.33203 10" stroke="#FFA100" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_1086_3188">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
